/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import BaseBigHugeCircuit from '../../implementation-common/big-huge-circuit';
import * as ReverseImplementation from './reverse-implementation';

export default class MultipleFeedbackBigHugeCircuit extends BaseBigHugeCircuit {
  @computed('c1', 'c2', 'c5', 'r1', 'r2') get circuitStageValues() {
    var c1 = this.c1;
    var c2 = this.c2;
    var c5 = this.c5;
    var r1 = this.r1;
    var r2 = this.r2;
    var result = ReverseImplementation.computeFromComponentValues(c1, c2, c5, r1, r2);
    return result;
  }
}
